import { render, staticRenderFns } from "./KeyNav.vue?vue&type=template&id=42a416c0"
import script from "./KeyNav.vue?vue&type=script&lang=js"
export * from "./KeyNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports